'use strict'

module.exports = function count (max) {
  var i = 0; max = max || Infinity
  return function (end, cb) {
    if(end) return cb && cb(end)
    if(i > max)
      return cb(true)
    cb(null, i++)
  }
}





//////////////////
// WEBPACK FOOTER
// ./~/pull-stream/sources/count.js
// module id = 388
// module chunks = 0